import { FaInstagramSquare, FaLinkedin, FaTwitter } from "react-icons/fa";

export const AboutData = [
  {
    title: "Prepaidmeter.ng - Powering Transparency in Energy Consumption",
    paragraph:"Prepaidmeter.ng is a trailblazing startup dedicated to transforming the energy landscape in Nigeria through cutting-edge solutions across energy metering, smart grids, minigrids, and comprehensive energy management.",
  },
  {
    // title: "Vision & Mission",
    paragraph:'Prepaidmeter.ng is a trailblazing startup dedicated to transforming the energy landscape in Nigeria through cutting-edge solutions across energy metering, smart grids, minigrids, and comprehensive energy management.',
    content: [
      {
        "Unmatched accuracy and reliability":"Our meters ensure precise and dependable measurement of energy consumption, empowering informed decision-making for individuals and businesses.",
        "Real-time data transparency:":"We go beyond basic readings, offering real-time data that empowers customers to understand their energy usage patterns and identify areas for cost savings and optimization.",
        "Advanced features at an accessible price point:":" Our meters boast a range of advanced features, including remote monitoring, tamper detection, and prepayment functionalities, all designed to be accessible and affordable for the Nigerian market.",
      },
    ],
  },
  {
    // title: "Our Solution",
    paragraph:"By leveraging Prepaidmeter.ng's state-of-the-art solutions, individuals, businesses, and communities can:",
    content: [
      {
        "Gain greater control over energy expenses:":"Our meters provide the data and insights needed to make informed choices about energy usage, leading to significant cost savings and improved budgeting.",
        "Embrace responsible energy consumption:":"By fostering a culture of energy awareness and efficiency, our solutions contribute to a greener future by reducing overall energy consumption and environmental impact.",
        "Empower informed decision-making:": "Our prepayment functionalities empower users to manage their energy expenses proactively, eliminating surprises and promoting financial well-being.",
        "Visitor Access:": "Ensure secure and convenient access management.",
      },
    ],
  },
  {
    paragraph:'Prepaidmeter.ng is committed to staying at the forefront of the Nigerian energy sector. We continuously innovate and develop solutions that address the evolving needs of our customers, making energy consumption transparent, affordable, and sustainable for all.'
  }
];


export const Social =[
  {
    id:1,
    icon: <FaTwitter className="text-[24px] text-white hover:text-secondary-dark" />,
    path:'https://twitter.com/PrepaidmeterNg'
  },
  {
    id:2,
    icon:  <FaInstagramSquare className="text-[24px] text-white hover:text-secondary-dark" />,
    path:'https://www.instagram.com/prepaidmeter.ng/'
  },
  {
    id:3,
    icon:   <FaLinkedin className="text-[24px] text-white hover:text-secondary-dark" />,
    path:'https://www.linkedin.com/company/iobotech/'
  },
]
